var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardContainer"},[_c('j-card-infos',{attrs:{"cta":'Commencer mon coaching'},on:{"validateCard":_vm.validateCard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }